import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { CurrencyEnum } from '../../../types/Currency'
import { WithdrawalSettings } from '../../../types/AppSettings'

const initialState: AppSettingsSliceState = {
  currency: CurrencyEnum.EUR,
  minimumWithdrawalAmountCents: 100,
  fixedWithdrawalFeeCents: 0,
}

export const appSettingsSlice = createSlice({
  name: 'appSettings',
  initialState,
  reducers: {
    setCurrency: (state, action: PayloadAction<CurrencyEnum>) => {
      state.currency = action.payload
    },
    setWithdrawalSettings: (
      state,
      action: PayloadAction<WithdrawalSettings>,
    ) => {
      state.minimumWithdrawalAmountCents =
        action.payload.minimumWithdrawalAmountCents
      state.fixedWithdrawalFeeCents = action.payload.fixedWithdrawalFeeCents
    },
  },
})

export const { setCurrency, setWithdrawalSettings } = appSettingsSlice.actions

/* Types */
export interface AppSettingsSliceState {
  currency: CurrencyEnum
  minimumWithdrawalAmountCents: number
  fixedWithdrawalFeeCents: number
}
